import Vue from 'vue'
import Router from 'vue-router'

// 按需加载书写形式

const Main = () => import('@/components/Main');
const Tinfo = () => import('@/components/Tinfo');
const Thumbail = () => import('@/components/Thumbnail');
const AllThumbail = () => import('@/components/AllThumbnail');
const RelayInfo = () => import('@/components/RelayInfo');
const OnlineR = () => import('@/components/OnlineR');
const UdpRInfo = () => import('@/components/UdpRInfo');
const CacheRInfo = () => import('@/components/CacheRInfo');
const UdpRelayInfo = () => import('@/components/UdpRelayInfo');
const CacheGridInfo = () => import('@/components/CacheGridInfo');

Vue.use(Router)


let routes =  [
    {
        path: '/',
        name: '',
        redirect: {
            name: 'Main'
        }
    },
    {
        path: '/Main',
        name: 'Main',
        component:Main
    },
    {
        path: '/Tinfo',
        name: 'Tinfo',
        component:Tinfo
    },
    {
        path: '/Thumbail',
        name: 'Thumbail',
        component:Thumbail
    },
    {
        path: '/AllThumbail',
        name: 'AllThumbail',
        component:AllThumbail
    },
    {
        path: '/RelayInfo',
        name: 'RelayInfo',
        component:RelayInfo
    },
    {
        path: '/OnlineR',
        name: 'OnlineR',
        component:OnlineR
    },
    {
        path: '/UdpRInfo',
        name: 'UdpRInfo',
        component:UdpRInfo
    },
    {
        path: '/CacheRInfo',
        name: 'CacheRInfo',
        component:CacheRInfo
    },
    {
        path: '/UdpRelayInfo',
        name: 'UdpRelayInfo',
        component:UdpRelayInfo
    },
    {
        path: '/CacheGridInfo',
        name: 'CacheGridInfo',
        component:CacheGridInfo
    },
]
const router =  new Router({
    routes,
    linkExactActiveClass: 'tabActive',
})



export default router
